import invert from 'lodash/invert';

import { TFunction } from '@lyearn/i18n';
import { FilterGroup, FilterOption } from '@/components/Filter/types';
import { TagsMenuItem } from '@/modules/corporate/modules/tags/types';
import { FilterOperatorEnum, FiltersInput, TagAvailableOnEnum } from '@/types/schema';

import { FilterGroups, FilterItemType } from '../types';

export const getSelectedFilterItemInput = (value: FiltersInput[], selectedProperty?: string) => {
  return value.find((val) => val.property === selectedProperty);
};

export const getAdaptedFilterGroups = (
  items: FilterGroups[],
  nonEditableFilterProperties?: string[],
): FilterGroup[] => {
  return items.map((groupItem) => {
    const options = groupItem.items.reduce<FilterOption[]>((acc, item) => {
      if (!nonEditableFilterProperties?.includes(item.property)) {
        acc.push({
          label: item.label,
          Icon: item.Icon,
          value: item.property,
        });
      }
      return acc;
    }, []);

    return { id: groupItem.id, label: groupItem.label, options };
  });
};

export const getPropertyToItemMap = (items: FilterGroups[]) => {
  const entityToItemMap: Record<string, FilterItemType> = {};

  items.forEach((groupItem) => {
    groupItem.items.forEach((item) => {
      entityToItemMap[item.property] = item;
    });
  });

  return entityToItemMap;
};

export const getDefaultOperators = (t: TFunction) => [
  {
    id: FilterOperatorEnum.In,
    value: FilterOperatorEnum.In,
    label: t('Common:Filter.Is'),
  },
  {
    id: FilterOperatorEnum.NotIn,
    value: FilterOperatorEnum.NotIn,
    label: t('Common:Filter.IsNot'),
  },
];

const TAG_AVAILABLE_ON = {
  [TagAvailableOnEnum.User]: 'user',
  [TagAvailableOnEnum.Event]: 'session',
  [TagAvailableOnEnum.Content]: 'content',
  [TagAvailableOnEnum.Okr]: 'okr',
  [TagAvailableOnEnum.Task]: 'task',
  [TagAvailableOnEnum.Consumption]: 'consumption',
};

export const getTagFilterKey = (tag: TagsMenuItem, availableOn: TagAvailableOnEnum) => {
  const tagAvailableOn = TAG_AVAILABLE_ON[availableOn];
  return `${tagAvailableOn}_tag::${tag.id}`;
};

export const getTagFromFilterKey = (property: string) => {
  const availableOn = (invert(TAG_AVAILABLE_ON) as Record<string, TagAvailableOnEnum>)[
    property.substring(0, property.indexOf('_'))
  ];

  return { id: property.split(':')[2], availableOn };
};
